import React, {Fragment} from 'react';
import ContentLoader from "react-content-loader"
import {Link} from 'react-router-dom';

import Avatar from '../../Avatar';
import createLink from "../../../../libs/createLink";
import {isNoFollowProfil} from "../../../../libs/helper";

const AvatarFriend = (props) => {
    let relLinkProfil = {};
    if(props.userFriendsInitialized){
        relLinkProfil = isNoFollowProfil(props) ? { rel: "nofollow" } : {};
    }
    return (
        <Fragment>
            {!props.userFriendsInitialized ? (
                <ContentLoader
                    ariaLabel={false}
                    height={60}
                    width={260}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="72" y="17" rx="4" ry="4" width="117" height="6.4"/>
                    <rect x="72" y="37" rx="3" ry="3" width="85" height="6.4"/>
                    <circle cx="29.4" cy="29.81" r="26.4"/>
                    <rect x="257.78" y="40.61" rx="0" ry="0" width="0" height="0"/>
                    <circle cx="247.8" cy="28.63" r="8.02"/>
                </ContentLoader>
            ) : (
                <div className="friends">
                    <Link to={createLink('userProfile', props)} {...relLinkProfil} >
                        <Avatar avatar={props.profile.avatar || ""}
                                gender={props.profile.gender} alt="" height={80} width={80}/>
                    </Link>
                </div>
            )}
        </Fragment>
    )
};

AvatarFriend.defaultProps = {
    _id: 0,
    slug: '',
    username: '',
    profile: {avatar: "", gender: "0"},
    isIndexed : false
};

export default AvatarFriend;
